<template>
  <div class="level-wrapper">
    <img :src="'../../static/images/' + ImgLink + '.png'" v-if="ImgLink !== ''"/>
  </div>
</template>
<script>
export default {
  props: {
    n: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      ImgLink: '',
      level: [{ordinary: 1},{whole: 2},{ gold: 3},{platinum: 4},{diamonds: 5},{vip: 6}]
    }
  },
  mounted() {
    this.ruleFun(this.n)
  },
  methods: {
    ruleFun(e) {
      this.level.map((v, i) => {
        if(v[Object.keys(v)[0]] === e) {
          this.ImgLink = Object.keys(v)[0]
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.level-wrapper {
  img {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/common/level.vue